import React, { useState } from 'react'
import { capitalizeAndRemoveUnderscores, downloadFile, limitWords } from '../../../utils/utils';
import { Button, message,  Table, Tooltip } from 'antd';
import fetchWithAuth from '../../../utils/customFetch';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../utils/axiosInstance';

export default function EsignStatus({ id, signuluResponse }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isSignLoading, setIsSignLoading] = useState(false);
  const navigate = useNavigate();

  const esignColumns = [
    {
      title: "Signed By",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => (
        <>
          <Tooltip title={text}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {limitWords(text, 100)}
            </div>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Signature Image",
      dataIndex: "signatureImage",
      ellipsis: true, // Enable ellipsis for the column
      render: (text) => <img src={text} alt="sign" className="h-20" />,
    },
    {
      title: "Signature Status",
      dataIndex: "status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
  ];

  const handleEsignDocDownload = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(`/esign/e_sign/download_document/`, { agreement_id: id })
      console.log(response)
      if (response && response.data) {
        const fileName = response.data?.executed_file_url.split("/")
        const file = fileName.pop();
        console.log(file)
        downloadFile(response.data?.executed_file_url , file)
        setIsLoading(false);
        message.success("File downloaded successfully.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error?.response?.data?.error)
      message.error(error?.response?.data?.error)
    }
  };

  const handleSendDocEsign = async () => {
    if (signuluResponse.statusCode !== "DRAFT") {
      return
    }
    try {
      setIsSignLoading(true)
      const getEsignUrl = await axiosInstance.post(`/esign/document/`, { agreement_id: id })
      window.open(getEsignUrl?.data?.redirect_url, "_blank", "noreferrer");
      setIsSignLoading(false)
    } catch (error) {
      setIsSignLoading(false)
      console.log(error)
      message.error("Failed For E-Sign")
    }

  }
  return (

    <>
      {/* <div className="text-sm font-semibold my-2">
        Signature Initiated By-
        <span className="font-medium mx-2">
          {signuluResponse?.senderName}
        </span>
      </div> */}
      {/* <div className="text-sm font-semibold my-2">
        Comments
        <span className="font-medium mx-2">
          {signuluResponse?.addComments
            ? signuluResponse?.addComments.map(
              (comment, index) => {
                return (
                  <span key={index}>
                    {index !== signuluResponse?.length() - 1
                      ? `${comment},`
                      : `${comment}`}
                  </span>
                );
              }
            )
            : "No Comments"}
        </span>
      </div> */}
      <div className="text-sm font-semibold my-2">
        Expiration Date-
        <span className="font-medium mx-2">
          {signuluResponse?.expirationDate}
        </span>
      </div>
      <div className="text-sm font-semibold my-2">
        E-sign Status-
        <span className="font-semibold mx-2">
          {signuluResponse?.statusCode?.toLowerCase() ===
            "approved" ? (
            <span className="bg-[#479D491A] text-[#479D49] px-2 py-2">
              {signuluResponse?.statusCode}
            </span>
          ) : signuluResponse?.statusCode?.toLowerCase() ===
            "rejected" ? (
            <span className="text-[#BA3928] bg-[#BA39281A] px-2 py-2">
              {signuluResponse?.statusCode}
            </span>
          ) : (
            <span className="text-[#F7CB73] bg-[#F7CB731A] px-2 py-2 ">
              {signuluResponse?.statusCode}
            </span>
          )}
        </span>
      </div>
      <div className="">
        <div className="text-sm font-semibold flex justify-between items-center h-10">
          <span>Recipients Details</span>
          <div className='flex gap-4'>
             {
              signuluResponse?.statusCode?.toUpperCase() === "DRAFT" && <Button
                loading={isSignLoading} // Show loading spinner
                disabled={isSignLoading}
                onClick={handleSendDocEsign}
                type="submit"
                className="flex items-center rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10 my-0"
              >
                Sign The Document
              </Button>
            }
          {signuluResponse?.statusCode?.toLowerCase() !==
            "pending" && (
              <Button
                // isLoading
                loading={isLoading} // Show loading spinner
                disabled={isLoading}
                onClick={handleEsignDocDownload}
                type="submit"
                className="flex items-center rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10 my-0"
              >
                Download Signed Document
              </Button>
            )}
            </div>
        </div>
        <Table
          dataSource={signuluResponse?.recepients}
          columns={esignColumns}
          pagination={false}
          scroll={{ x: "max-content" }}
          bordered
          className="mb-4 text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
        />
      </div>
    </>
  )
}
